import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/site/Reveal";
import { resolveImg } from "@/lib/api";

const CHAPTERS = {
  en: [
    { n: "01", t: "Two flags, one kitchen", b: "We bring together the tables of Guatemala and Colombia — the quetzal and the vueltiao hat under one roof, cooked with the same love our grandmothers used." },
    { n: "02", t: "Baked before sunrise", b: "Our ovens start at 6 AM. Conchas, sweet-bread boxes and celebration cakes are made fresh in-house, every single day, until midnight." },
    { n: "03", t: "A plate that feels like home", b: "From bandeja paisa to pepián, from wood-fired pizza to a loaded Colombian hot dog — hearty, honest food for the whole neighborhood." },
  ],
  es: [
    { n: "01", t: "Dos banderas, una cocina", b: "Unimos las mesas de Guatemala y Colombia — el quetzal y el sombrero vueltiao bajo un mismo techo, cocinado con el mismo amor de nuestras abuelas." },
    { n: "02", t: "Horneado antes del amanecer", b: "Nuestros hornos encienden a las 6 AM. Conchas, cajas de pan dulce y pasteles para toda ocasión, hechos en casa, todos los días, hasta la medianoche." },
    { n: "03", t: "Un plato que sabe a hogar", b: "Desde la bandeja paisa hasta el pepián, de la pizza al horno al perro caliente colombiano — comida honesta y abundante para todo el barrio." },
  ],
};

export const Manifesto = ({ settings }) => {
  const { lang, t, pick } = useLang();
  const chapters = CHAPTERS[lang];

  return (
    <section id="story" className="py-24 md:py-32 relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="overline text-terracotta mb-4">{t("story_kicker")}</p>
        </Reveal>
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-14 items-start">
          <Reveal delay={0.1}>
            <div className="lg:sticky lg:top-28">
              <h2 className="font-serif text-4xl md:text-6xl leading-[0.95] tracking-tight text-ink">
                {lang === "en" ? "Handmade heritage, served daily" : "Herencia hecha a mano, servida cada día"}
              </h2>
              <p className="font-body text-ink/70 mt-6 leading-relaxed max-w-md">{pick(settings, "about")}</p>
              <div className="mt-8 arch overflow-hidden max-w-sm shadow-2xl shadow-ink/15">
                <img
                  src={resolveImg((settings?.hero_images || [])[2]) || "https://customer-assets-rejwkqb3.emergentagent.net/job_menu-restaurant-pro/artifacts/iv4087z1_IMG-20260826-WA0064.webp"}
                  alt="kitchen"
                  className="w-full h-72 object-cover"
                />
              </div>
            </div>
          </Reveal>

          <div className="space-y-14">
            {chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <div className="grid grid-cols-[auto_1fr] gap-6 md:gap-8 border-t border-ink/15 pt-8">
                  <span className="font-serif text-5xl md:text-7xl text-terracotta/90 leading-none">{c.n}</span>
                  <div>
                    <h3 className="font-label font-bold text-xl md:text-2xl text-ink mb-3">{c.t}</h3>
                    <p className="font-body text-ink/70 leading-relaxed">{c.b}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
